<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark">
      <b-navbar-brand href="#" class="brand-logo p-1">
        <img src="../assets/aslogo.png" width="40" alt="Kitten">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-none d-sm-block mr-2">
            <b-link to="/invoices" class="text-decoration-none menu-color">
              INVOICES
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="mr-2">
            <b-link to="/local-stock" class="text-decoration-none menu-color">
              SEARCH AND ORDER
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="mr-2">
            <b-link to="/regos-parts" class="text-decoration-none menu-color">
              REGOS
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-none d-sm-block mr-2">
            <b-link to="/virtuals" class="text-decoration-none menu-color">
              WORKSHOP
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-none d-sm-block mr-2">
            <b-link to="/manual" class="text-decoration-none menu-color">
              BD STOCK
            </b-link>
          </b-nav-item>

          <b-nav-item-dropdown v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                               text="AIRSUSPENSION" class="dropdown-nav-link">

            <b-dropdown-item>
              <b-link to="/as/scan" class="text-decoration-none">
                STOCK MANAGEMENT
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/as/products" class="text-decoration-none">
                PRODUCTS IN STOCK
              </b-link>
            </b-dropdown-item>

          </b-nav-item-dropdown>

          <b-nav-item-dropdown v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
            text="CHECKS" class="dropdown-nav-link">

            <b-dropdown-item>
              <b-link to="/products-on-location" class="text-decoration-none">
                CHECK STOCK
              </b-link>
            </b-dropdown-item>

            <b-dropdown-item>
              <b-link to="/confirm-received" class="text-decoration-none">
                CHECK BOX ITEMS
              </b-link>
            </b-dropdown-item>

          </b-nav-item-dropdown>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-none d-sm-block mr-2">
            <b-link to="/ref-lager" class="text-decoration-none menu-color">
              REF LAGER
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-lg-none mr-2">
            <b-link to="/scanner" class="text-decoration-none menu-color">
              SCANNER
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role !== fixed.roles.Merchant" class="d-none d-sm-block mr-2">
            <b-link to="/poland-orders" class="text-decoration-none menu-color">
              ORDERS
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role !== fixed.roles.Merchant" class="d-none d-sm-block mr-2">
            <b-link to="/processed-orders" class="text-decoration-none menu-color">
              PROCESSING
            </b-link>
          </b-nav-item>
          <b-nav-item v-if="user.role !== fixed.roles.Merchant" class="d-none d-sm-block mr-2">
            <b-link to="/packed-orders" class="text-decoration-none menu-color">
              PACKAGES
            </b-link>
          </b-nav-item>

          <b-nav-item-dropdown v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                               text="STATS" class="dropdown-nav-link">
            <b-dropdown-item>
              <b-link to="/stats/history" class="text-decoration-none">
                HISTORY
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/workshop-stats" class="text-decoration-none">
                WORKSHOP
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/poland-stats" class="text-decoration-none">
                POLAND
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/website-stats" class="text-decoration-none">
                BDBILDELER
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/regos-stats" class="text-decoration-none">
                REGOS
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/as-stats" class="text-decoration-none">
                AIRSUSPENSION
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/invoices" class="text-decoration-none">
                INVOICES
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/total-stock-value" class="text-decoration-none">
                TOTAL STOCK
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="user.showHidden">
              <b-link to="/stats/overview" class="text-decoration-none">
                PLATFORM INSIGHTS
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="user.showHidden">
              <b-link to="/supplies-demo" class="text-decoration-none">
                SUPPLIERS DEMO
              </b-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <!-- Merchant Routes -->
<!--          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Merchant"-->
<!--                      class="d-none d-sm-block mr-2">-->
<!--            <b-link to="/merchant-pos" class="text-decoration-none menu-color">-->
<!--              POS-->
<!--            </b-link>-->
<!--          </b-nav-item>-->
          <b-nav-item v-if="user.role === fixed.roles.Merchant"
                      class="d-none d-sm-block mr-2">
            <b-link to="/merchant-order" class="text-decoration-none menu-color">
              ORDER
            </b-link>
          </b-nav-item>
          <b-nav-item v-if="user.role === fixed.roles.Merchant"
                      class="d-none d-sm-block mr-2">
            <b-link to="/merchant-order-history" class="text-decoration-none menu-color">
              ORDER HISTORY
            </b-link>
          </b-nav-item>

        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <span class="text-uppercase">{{ user.username || 'Please Log In' }}</span>
            </template>
            <b-dropdown-item href="#" disabled>Profile</b-dropdown-item>
            <b-dropdown-item @click="logOut">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '@/fixed';

export default {
  computed: {
    fixed() {
      return fixed;
    },
  },
  props: ['user'],
  methods: {
    async logOut() {
      try {
        await axios.get(`${fixed.API_URL}/log-out`, { withCredentials: true });
        localStorage.removeItem('user');
        // await this.$router.push('/login');
        window.location.reload();
      } catch (err) {
        this.$toast.error(err?.message || 'log out error');
      }
    },
  },
};
</script>

<style>
/* Mobile-first base styles */
.nav-link {
  font-size: 1rem;
  padding: 0.5rem 1rem;
  color: #f8f9fa !important;
}

/* Dropdown toggle button */
.nav-item.dropdown .nav-link {
  font-size: 1rem;
  padding: 0.5rem 1rem;
  color: #f8f9fa !important;
}

/* Menu links - all white by default */
.menu-color,
.nav-link > span {
  color: #f8f9fa !important;
  font-size: 1rem;
}

/* Active/hover state - gray */
.menu-color:hover,
.menu-color:active,
.menu-color:focus,
.nav-link:hover,
.nav-link:active,
.nav-link:focus {
  color: #6c757d !important;
}

/* Dropdown link styling - white text */
.dropdown-nav-link .nav-link {
  font-size: 1rem;
  color: #f8f9fa !important;
}

.dropdown-nav-link .nav-link:hover,
.dropdown-nav-link .nav-link:active,
.dropdown-nav-link .nav-link:focus {
  color: #6c757d !important;
}

/* Brand logo */
.brand-logo {
  background-color: #44484a;
  cursor: default;
}

/* Navbar toggler */
.navbar-toggler {
  border-color: rgba(255, 255, 255, 0.5);
  padding: 0.5rem 0.75rem;
}

.navbar-toggler:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.25);
}

/* User dropdown button */
.navbar-nav .nav-item.dropdown .nav-link {
  font-size: 1rem;
  color: #f8f9fa !important;
}

.navbar-nav .nav-item.dropdown .nav-link:hover {
  color: #6c757d !important;
}

/* Mobile collapse menu */
#nav-collapse {
  margin-top: 0.5rem;
}

/* Dropdown menu styling - DARK background for visibility */
.dropdown-menu {
  background-color: #212529 !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
}

/* Dropdown items - dark background, white text */
.dropdown-item {
  color: #f8f9fa !important;
  background-color: #212529 !important;
  padding: 0.5rem 1.5rem;
  font-size: 0.95rem;
}

/* Links inside dropdown items - white text */
.dropdown-item a,
.dropdown-item .nav-link {
  color: #f8f9fa !important;
  text-decoration: none !important;
  display: block;
}

/* Dropdown item hover/focus/active states */
.dropdown-item:hover,
.dropdown-item:focus,
.dropdown-item:active {
  background-color: #495057 !important;
  color: #fff !important;
}

.dropdown-item:hover a,
.dropdown-item:focus a,
.dropdown-item:active a,
.dropdown-item:hover .nav-link,
.dropdown-item:focus .nav-link,
.dropdown-item:active .nav-link {
  color: #fff !important;
}

/* Disabled dropdown items */
.dropdown-item:disabled,
.dropdown-item.disabled {
  color: #6c757d !important;
  background-color: #212529 !important;
}

/* Mobile menu items spacing */
@media (max-width: 991.98px) {
  /* Force all nav items (including dropdowns) to have zero left margin/padding */
  .navbar-nav > li,
  .navbar-nav > .nav-item,
  ul.navbar-nav > li {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  /* Ensure all nav links inside have consistent left padding */
  .navbar-nav > li > a,
  .navbar-nav > .nav-item > a,
  .navbar-nav > li > .nav-link,
  .navbar-nav > .nav-item > .nav-link {
    padding-left: 1rem !important;
    margin-left: 0 !important;
  }

  /* Dropdown menu styling */
  .navbar-nav .dropdown-menu {
    border: none !important;
    background-color: #212529 !important;
    margin-left: 0 !important;
    position: static !important;
    float: none;
  }

  .dropdown-item {
    color: #f8f9fa !important;
    background-color: #212529 !important;
    padding: 0.5rem 1rem;
  }

  .dropdown-item:hover,
  .dropdown-item:focus {
    background-color: #495057 !important;
    color: #fff !important;
  }

  .dropdown-item:hover a,
  .dropdown-item:focus a {
    color: #fff !important;
  }
}

/* Tablet and small desktop */
@media (min-width: 576px) and (max-width: 991.98px) {
  .nav-link {
    font-size: 1rem;
  }

  .menu-color {
    font-size: 1rem;
  }
}

/* Desktop - use viewport width for scaling */
@media (min-width: 992px) {
  .nav-link {
    font-size: 0.9vw;
    padding: 0.5rem 0.75rem;
  }

  .menu-color {
    font-size: 0.9vw;
  }

  .dropdown-nav-link .nav-link {
    font-size: 0.9vw;
  }

  .navbar-nav .nav-item.dropdown .nav-link {
    font-size: 0.9vw;
  }

  .dropdown-item {
    font-size: 0.85vw;
  }

  .dropdown-item a,
  .dropdown-item .nav-link {
    font-size: 0.85vw;
  }
}

/* Large desktop - cap the font size */
@media (min-width: 1400px) {
  .nav-link {
    font-size: 0.875rem;
  }

  .menu-color {
    font-size: 0.875rem;
  }

  .dropdown-nav-link .nav-link {
    font-size: 0.875rem;
  }

  .navbar-nav .nav-item.dropdown .nav-link {
    font-size: 0.875rem;
  }

  .dropdown-item {
    font-size: 0.8125rem;
  }

  .dropdown-item a,
  .dropdown-item .nav-link {
    font-size: 0.8125rem;
  }
}
</style>
